//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  import {getDistrict,getHospital} from '@/api/yq'
  import { getWeixinConfig } from '@/api/weixin'

  export default {

    data() {
      return {
        map_url:'https://devlop.plian.net/map',
        country:{},
        zj:{},
        nb:{},
        wh:{},
        hb:{},
        nb_list:[],
        zj_list:[],
        image:'',
        history:1,
        show_yq:true,
        show_map:true,
        data_info:[],
        /*nb_diagnoseNum:0,
         nb_dieNum:0,
         nb_cueNum:0,
         zj_diagnoseNum:0,
         zj_dieNum:0,
         zj_cueNum:0,*/
        weixinConfig:{},
        weixinShareUrl:'https://ypstatic.cnnb.com.cn/yppage-server/index.html#/',
        bodyHeight:'',
        info1:'',
        show_overlayer:false,
        show_dialog:false,
        show_close:false
        /*info2:''*/
      };
    },


    methods: {
      get_yq_info(){
        let params = {}
        getDistrict(params).then((res) => {
          if(res.code == 0){
            this.country = res.data.country;
            this.nb_list = res.data.nbList;
            this.zj_list = res.data.zjList;
            this.zj = res.data.zj;
            this.nb = res.data.nb;
            this.wh = res.data.wh;
            this.hb = res.data.hb;
            this.image = res.data.image;
            this.info1 = res.data.info1
            /*this.info1 = res.data.info1;
             this.info2 = res.data.info2;*/
            var data = [];
            for(var i =0;i<this.nb_list.length;i++){
              /*this.nb_diagnoseNum = this.nb_diagnoseNum + this.nb_list[i].diagnoseNum;
               this.nb_dieNum = this.nb_dieNum + this.nb_list[i].dieNum;
               this.nb_cueNum = this.nb_cueNum + this.nb_list[i].cueNum;*/
              var obj = {name:this.nb_list[i].name,value:this.nb_list[i].diagnoseNum};
              data.push(obj)
            }
            //this.drawLine(data);
            /*for(var j =0;j<this.nb_list.length;j++){
             this.zj_diagnoseNum = this.zj_diagnoseNum + this.zj_list[j].diagnoseNum;
             this.zj_dieNum = this.zj_dieNum + this.zj_list[j].dieNum;
             this.zj_cueNum = this.zj_cueNum + this.zj_list[j].cueNum;
             }*/

            var title = "实时更新数据！国家省宁波新冠肺炎地图上线，直达定点医院";
            var subTitle = "疫情实时追踪，更可一键查看宁波定点医院地图"

            this.refresh(title,subTitle,'');
          }

        })
      },
      get_yq_hospital(){
        let params = {}
        getHospital(params).then((res) => {
          if(res.code == 0){
            var list = res.data;
            for(var i =0;i<list.length;i++){
              var arr = [list[i].y,list[i].x,"地址："+list[i].address+"","医院名称："+list[i].name+"</br>"];
              this.data_info.push(arr)
            }
            this.$nextTick(() => {
              this.onLoad();
              this.show_map = false;
            })

          }

        })
      },
      change(obj){
        if(this.history != obj){
          $("#c"+obj).addClass("active");
          $("#c"+obj).removeClass("active-null");
          $("#c"+this.history).removeClass("active");
          $("#c"+this.history).addClass("active-null");
        }

        if(obj == 1){
          this.show_yq = true;
          this.show_map = false;
        }else{
          this.show_yq = false;
          this.show_map = true;
        }
        this.history = obj
      },
      drawLine(data){
        var uploadedDataURL2 = this.map_url + "/ningbo.geojson";
        var echarts = require('echarts');
        let myChart2 = echarts.init(document.getElementById('myChart2'));
        var geoCoordMap = {};
        //myChart2.showLoading();
        $.getJSON(uploadedDataURL2, function(geoJson) {
          echarts.registerMap('ningbo', geoJson);

          /*获取地图数据*/
          var mapFeatures = echarts.getMap('ningbo').geoJson.features;
//  console.log(mapFeatures)
          mapFeatures.forEach(function(v) {
            // 地区名称
            var name = v.properties.name;
            // 地区经纬度
            if(name == '慈溪市'){
              geoCoordMap[name] = v.properties.center;
            }else{
              geoCoordMap[name] = v.properties.centroid;
            }
            //geoCoordMap[name] = v.properties.centroid;

          });

          //console.log(data)
          var max = 480,
            min = 9; // todo
          var maxSize4Pin = 150,
            minSize4Pin = 20;
          var convertData = function(data) {
            var res = [];
            for (var i = 0; i < data.length; i++) {
              var geoCoord = geoCoordMap[data[i].name];

              if (geoCoord) {
                res.push({
                  name: data[i].name,
                  value: geoCoord.concat(data[i].value),
                });
              }
            }
            return res;
          };

          myChart2.option = {
            /*visualMap: {
             min: 0,
             max: 1000,
             left: 0,
             bottom: 0,
             showLabel: !0,
             text: ["高", "低"],
             pieces: [{
             gt: 100,
             label: "> 100 人",
             color: "#7f1100"
             }, {
             gte: 10,
             lte: 100,
             label: "10 - 100 人",
             color: "#ff5428"
             }, {
             gte: 1,
             lt: 10,
             label: "1 - 9 人",
             color: "#ff8c71"
             }, {
             gt: 0,
             lt: 1,
             label: "疑似",
             color: "#ffd768"
             }, {
             value: 0,
             color: "#ffffff"
             }],
             show: !0
             },*/
            /*visualMap: {
             min: 0,
             max: 1000,
             left: 26,
             bottom: 40,
             showLabel: !0,
             text: ["高", "低"],
             pieces: [{
             gt: 100,
             label: "> 100 人",
             color: "#7f1100"
             }, {
             gte: 10,
             lte: 100,
             label: "10 - 100 人",
             color: "#ff5428"
             }, {
             gte: 1,
             lt: 10,
             label: "1 - 9 人",
             color: "#ff8c71"
             }, {
             value: 0,
             color: "#ffffff"
             }],
             show: !0
             },*/
            visualMap: {
              show: true,
              min: 0,
              max: 50,
              left: 'left',
              top: 'bottom',
              text: ['确诊人数'], // 文本，默认为数值文本
              //calculable: true,
              seriesIndex: [1],
              showLabel: !0,
              textGap:5,
              /*inRange: {
               color: ['#ffffff', '#ff8c71','#ff5428','#7f1100'] // 蓝绿
               }*/
              pieces: [{
                gt: 10,
                label: "> 10 人",
                color: "#691C1F"
              },{
                gte: 6,
                lt: 10,
                label: "6 - 10 人",
                color: "#B8564A"
              },
                {
                  gte: 1,
                  lt: 5,
                  label: "1 - 5 人",
                  color: "#FFDDCD"
                }, {
                  value: 0,
                  label: "0人",
                  color: "#FBECCF"
                }],
            },
            geo: {
              map: "ningbo",
              roam: !1,
              scaleLimit: {
                min: 1,
                max: 2
              },
              zoom: 1.25,
              label: {
                normal: {
                  show: !0,
                  fontSize: "10",
                  color: "rgba(0,0,0,0.7)"
                }
              },
              itemStyle: {
                normal: {
                  //shadowBlur: 50,
                  //shadowColor: 'rgba(0, 0, 0, 0.2)',
                  borderColor: "rgba(0, 0, 0, 0.2)",
                  areaColor: "#FADECF",
                },
                emphasis: {
                  areaColor: "#FADECF",
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  borderWidth: 0
                }
              }
            },
            series: [{
              name: '散点',
              type: 'scatter',
              coordinateSystem: 'geo',
              data: convertData(data),
              symbolSize: function(val) {
                return val[2] / 10000;
              },
              label: {
                normal: {
                  formatter: '{b}',
                  position: 'bottom',
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              itemStyle: {
                normal: {
                  color: '#05C3F9'
                }
              }
            },{
              name: "确诊病例",
              type: "map",
              geoIndex: 0,
              data: data
            },{
              name: '点',
              type: 'scatter',
              coordinateSystem: 'geo',
              symbol: 'pin', //气泡
              symbolSize: function(val) {
                var a = (maxSize4Pin - minSize4Pin) / (max - min);
                var b = minSize4Pin - a * min;
                b = maxSize4Pin - a * max;
                return 35  ;
              },
              label: {
                normal: {
                  show: true,
                  formatter: function(params) {
                    return params.data.value[2]
                  },
                  textStyle: {
                    color: '#fff',
                    fontSize: 9,
                  }
                }

              },
              itemStyle: {
                normal: {
                  color: '#4487FA', //标志颜色
                }
              },
              zlevel: 10,
              data: convertData(data),
            },
            ]
          };
          myChart2.setOption(myChart2.option);
        });
      },
      /*addClickHandler(content,marker){
       marker.addEventListener("click",function(e){
       this.openInfo(content,e)}
       );
       },
       openInfo(content,e){
       var point = e.lnglat;
       marker = new T.Marker(point);// 创建标注
       var markerInfoWin = new T.InfoWindow(content,{offset:new T.Point(0,-30)}); // 创建信息窗口对象
       map.openInfoWindow(markerInfoWin,point); //开启信息窗口
       },*/
      onLoad(){
        var map;
        var zoom = 10;
        //初始化地图对象
        /*var data_info = [[116.417854,39.921988,"地址：北京市东城区王府井大街88号乐天银泰百货八层"],
         [116.406605,39.921585,"地址：北京市东城区东华门大街"],
         [116.412222,39.912345,"地址：北京市东城区正义路甲5号"]
         ];*/
        map = new T.Map("mapDiv");

        //设置显示地图的中心点和级别
        map.centerAndZoom(new T.LngLat(121.54128,29.87067), zoom);

        for(var i=0;i<this.data_info.length;i++){
          var marker = new T.Marker(new T.LngLat(this.data_info[i][0],this.data_info[i][1]));  // 创建标注
          var content = this.data_info[i][3]+this.data_info[i][2];
          map.addOverLay(marker);               // 将标注添加到地图中
          addClickHandler(content,marker);
        }

        function addClickHandler(content,marker){
          marker.addEventListener("click",function(e){
            openInfo(content,e)}
          );
        }
        function openInfo(content,e){
          var point = e.lnglat;
          marker = new T.Marker(point);// 创建标注
          var markerInfoWin = new T.InfoWindow(content,{offset:new T.Point(0,-30)}); // 创建信息窗口对象
          map.openInfoWindow(markerInfoWin,point); //开启信息窗口
        }
        $(".tdt-bottom")[0].style.display = 'none';
      },
      look_info(){
        this.show_overlayer = true;
        this.show_dialog = true;
        this.show_close = true;
      },
      close(){
        this.show_overlayer = false;
        this.show_dialog = false;
        this.show_close = false;
      },
      refresh (title,subTitle,imgTb1) {
        var tb1 = '';
        if(imgTb1 == null || imgTb1 == ''){
          tb1 = 'https://img.cnnb.com.cn/mixmedia/2020/01/31/5159f076-7b59-4c47-8b30-bf6a6d85de34size_w_210_h_210.jpg';
        }else{
          tb1 = imgTb1;
        }
        if(!subTitle){
          this.weixinConfig.desc = subTitle;
        }
//2.特殊微信二次分享
        var shareData = {
          title : title, // 分享标题
          desc : subTitle,
          imgUrl : "https://img.cnnb.com.cn/mixmedia/2020/01/31/5159f076-7b59-4c47-8b30-bf6a6d85de34size_w_210_h_210.jpg",
          imageThumbnail:tb1,
          timeline : this.weixinShareUrl+"serve/select?type=wxfs",//分享到微信朋友圈
          appmessage : this.weixinShareUrl+"serve/select?type=wx",//分享到微信
          qq : this.weixinShareUrl+"serve/select?type=qq",//分享到QQ
          weibo : this.weixinShareUrl+"serve/select?type=wb",//分享到QQ
          qzone : this.weixinShareUrl+"serve/select?type=qz"
        };

        wx.ready(function(){
          wx.updateAppMessageShareData({
            title: shareData.title, // 分享标题
            desc: shareData.desc,// 分享描述
            link: shareData.timeline, // 分享链接
            imgUrl: shareData.imageThumbnail, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              this.saveForward();
            },
          });

          wx.updateTimelineShareData({
            title: shareData.title, // 分享标题
            desc: shareData.desc,// 分享描述
            link: shareData.appmessage, // 分享链接
            imgUrl: shareData.imageThumbnail, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              this.saveForward();
            },
          });

          wx.onMenuShareWeibo({
            title: shareData.title, // 分享标题
            desc: shareData.desc,// 分享描述
            link: shareData.qq, // 分享链接
            imgUrl: shareData.imageThumbnail, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              this.saveForward();
            },
          });

        });
      },





    },
    created(){
      let params = {url:window.location.href.split("#")[0],domain:"https://ypstatic.cnnb.com.cn/yppage-server/index.html"};
      getWeixinConfig(params).then((res) => {
        this.weixinConfig = res.data;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: this.weixinConfig.appId, // 必填，公众号的唯一标识
          timestamp: this.weixinConfig.timestamp, // 必填，生成签名的时间戳
          nonceStr: this.weixinConfig.nonceStr, // 必填，生成签名的随机串
          signature: this.weixinConfig.signature,// 必填，签名，见附录1
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareWeibo',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareQZone'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      })

    },
    mounted () {
      //this.drawLine();
      this.bodyHeight = ($(window).height()-32)+"px";
      this.get_yq_info();
      this.get_yq_hospital();
      document.title= "实时更新数据！国家省宁波新冠肺炎地图上线，直达定点医院";
    },
  };





// WEBPACK FOOTER //
// ./src/pages/fy/selectInfo2.vue